import React from "react";

// MUI
import { DialogTitle, IconButton, Typography } from "@mui/material";

// MUI-Icons
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  children: string;
  onClose: () => void;
};

const DialogBoxTitle = ({ children, onClose }: Props) => {
  return (
    <DialogTitle id="customized-dialog-title">
      <Typography variant="subtitle1" component="span">
        {children}
      </Typography>

      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "0.75rem",
            top: "0.75rem",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default DialogBoxTitle;
